import gql from 'graphql-tag'

export const SERVICE_CATEGORIES = gql`
  query ServiceCategories($filter: ServiceCategoryFilter) {
    serviceCategories(filter: $filter) {
      isSuccessful
      message
      serviceCategories {
        data {
          name
          companyId
          serviceCategoryId
        }
        pagination {
          endCursor
          page
          show
          startCursor
          total
        }
      }
    }
  }
`

export const CREATE_SERVICE_CATEGORIES = gql`
  mutation CreateServiceCategory($input: CreateServiceCategoryInput!) {
    createServiceCategory(input: $input) {
      isSuccessful
      message
      createServiceCategory {
        name
        serviceCategoryId
      }
    }
  }
`

export const UPDATE_SERVICE_CATEGORIES = gql`
  mutation UpdateServiceCategory($input: UpdateServiceCategoryInput!) {
    updateServiceCategory(input: $input) {
      isSuccessful
      message
      updateServiceCategory {
        serviceCategoryId
        name
      }
    }
  }
`

export const DELETE_SERVICE_CATEGORIES = gql`
  mutation DeleteServiceCategory($input: DeleteServiceCategoryInput!) {
    deleteServiceCategory(input: $input) {
      isSuccessful
      message
      deleteServiceCategory {
        serviceCategoryId
        name
      }
    }
  }
`
